import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ??
  "https://jnoeucdmnuffzctyhomt.supabase.co";
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ??
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impub2V1Y2RtbnVmZnpjdHlob210Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIxMjIyNjcsImV4cCI6MjA5NzY5ODI2N30.kGz_L8jYiBsKQZM_cIi9w0WsHnRGw2--TN4yMwnCuLM";

// Typed as `any` for now: without a generated `Database` type,
// supabase-js 2.43+ defaults table Insert/Update types to `never`,
// which is what was causing the TS2345 build error. Once you generate
// real types from the Supabase dashboard (Project Settings > API),
// swap this to `createClient<Database>(supabaseUrl, supabaseAnonKey)`.
export const supabase = createClient<any>(supabaseUrl, supabaseAnonKey);
